
import { useEffect, useRef } from "react";

const NAG_KEY = "newsletter_nag_timestamp";
const NAG_INTERVAL_DAYS = 30;

const shouldShowNag = (checked: boolean) => {


    if (checked)
        return false;

    const stored = localStorage.getItem(NAG_KEY);
    if (!stored) return true;

    const lastTime = new Date(stored);
    if (isNaN(lastTime.getTime())) return true;

    const now = new Date();
    const diffMs = now.getTime() - lastTime.getTime();
    const diffDays = diffMs / (1000 * 60 * 60 * 24);

    return diffDays >= NAG_INTERVAL_DAYS;
};

const updateNagTimestamp = () => {
    localStorage.setItem(NAG_KEY, new Date().toISOString());
};

type NewsLetterNagProp = {
    onValueChange: (checked: boolean) => void;
    checked: boolean;
    saving: boolean;
};

const NewsLetterNag = ({ checked, saving, onValueChange }: NewsLetterNagProp) => {
    const modalRef = useRef<HTMLDivElement | null>(null);

    type BsModalInstance = {
        show(): void;
        hide(): void;
        dispose(): void;
    };

    const bsModalRef = useRef<BsModalInstance | null>(null);

    const win = window as unknown as {
        bootstrap?: { Modal: new (el: HTMLElement, opts?: any) => BsModalInstance };
    };

    // Run once on mount
    useEffect(() => {
        if (shouldShowNag(checked) && modalRef.current && win.bootstrap?.Modal) {
            bsModalRef.current = new win.bootstrap.Modal(modalRef.current, {
                backdrop: "static",
                keyboard: true,
            });

            bsModalRef.current.show();
        }


        return () => {
            bsModalRef.current?.dispose?.();
            bsModalRef.current = null;
        };
    }, []);

    const closeModal = () => {
        updateNagTimestamp();
        bsModalRef.current?.hide();
    };

    return (
        <div
            className="modal fade"
            id="modalNewsLetterNag"
            tabIndex={-1}
            aria-modal="true"
            role="dialog"
            ref={modalRef}
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5">Motta nyhetsbrev</h1>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={closeModal}
                            aria-label="Lukk"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <p className="mb-4">
                            Vi sender av og til e-post til deg med relevant informasjon,
                            innsikt og tilbud knyttet til våre tjenester for bedrifter.
                            Innholdet er ment å gi deg inspirasjon og kunnskap om hvordan du
                            kan synliggjøre og utvikle din virksomhet.
                        </p>
                        <div className="form-check mb-4">
                            { saving ? <span className="spinner-border spinner-border-sm form-check-input"></span> : <input
                                className="form-check-input"
                                type="checkbox"
                                id="nyhetsbrevModal"
                                onChange={(e) => onValueChange(e.target.checked)}
                                checked={checked}
                                disabled={saving}
                            />}
                            
                            <label
                                className="form-check-label fw-semibold"
                                htmlFor="nyhetsbrevModal"
                            >
                                Jeg ønsker å motta nyhetsbrev fra 1881
                            </label>{" "}
                            <span
                                className="d-inline-block a"
                                role="button"
                                data-bs-toggle="modal"
                                data-bs-target="#modalNewsLetter"
                                onClick={closeModal}
                            >
                                Les mer
                            </span>
                        </div>
                        <p className="text-muted mb-0 lh-sm cc-fs-xs">
                            Du kan enkelt melde deg av nyhetsbrevet fra lenke i mottatt
                            nyhetsbrev eller her på Min bedrift.
                        </p>
                    </div>
                    <div className="modal-footer">
                        <button
                            className="btn btn-light border"
                            type="button"
                            onClick={closeModal}
                            aria-label="Lukk"
                        >
                            Lukk vindu
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsLetterNag;